export function NavigationDrawer() {
  const handler = () => {
    let trigger;
    let body;

    function _setInit() {
      body = document.body;
      trigger = document.querySelectorAll('.common_trigger');
    }
    function _setTrigger() {
      if (trigger) {
        trigger.forEach((el) => {
          document.addEventListener('keydown', (event) => (event.key === 'Escape' ? _triggerFunction() : false));
          el.addEventListener('click', _triggerFunction);
        });
      }
    }
    function _triggerFunction() {
      if (body.classList.contains('drawer-active')) {
        body.classList.remove('drawer-active');
      } else {
        body.classList.add('drawer-active');
      }
    }
    return (function () {
      _setInit();
      _setTrigger();
    })();
  };

  window.addEventListener('load', () => {
    handler();
  });
}

NavigationDrawer();
